<app-modal-template
	[title]="'Server Info'"
	[iconId]="43"
	(saveClicked)="close()"
	[showCancel]="false"
	[saveText]="'Close'"
	[saveIcon]="['fass', 'times']"
>
	<!-- Loading Spinner -->
	<app-spinner *ngIf="loading" [@fadeInOutAnimation]></app-spinner>

	<!-- Content -->
	<div class="server-info-content" *ngIf="!loading" [@fadeInOutAnimation]>
		<div>
			<div class="label">Version</div>
			<div class="info">{{ info.version }}</div>
		</div>

		<div>
			<div class="label">Environment</div>
			<div class="info">{{ info.environment }}</div>
		</div>

		<div>
			<div class="label">Site Name</div>
			<div class="info">{{ info.siteName }}</div>
		</div>

		<div>
			<div class="label">Instance ID</div>
			<div class="info">{{ info.instanceId }}</div>
		</div>

		<div>
			<div class="label">Server Start Date</div>
			<div class="info">{{ info.serverStartDate | moment: 'MM/DD/YYYY hh:mm:ss A' }}</div>
		</div>

		<div>
			<div class="label">Security Refresh Date</div>
			<div class="info">{{ info.lastSecurityRefresh | moment: 'MM/DD/YYYY hh:mm:ss A' }}</div>
		</div>

		<div>
			<div class="label">Environment Settings Refresh Date</div>
			<div class="info">{{ info.lastEnvironmentSettingsRefresh | moment: 'MM/DD/YYYY hh:mm:ss A' }}</div>
		</div>

		<div>
			<div class="label">Region</div>
			<div class="info">{{ info.region }}</div>
		</div>

		<div>
			<div class="label">SignalR Status</div>
			<div class="info">
				{{ info.signalRStatus }}
				<app-db-icon
					[iconId]="41"
					class="clickable"
					matTooltip="Reconnect"
					*ngIf="info.signalRStatus == 'Disconnected'"
					(click)="reconnectSignalR()"
					[spin]="reconnecting"
				></app-db-icon>
			</div>
		</div>
	</div>
</app-modal-template>
